import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cargo-type-field',
  templateUrl: './cargo-type-field.component.html',
  styleUrls: ['./cargo-type-field.component.scss']
})
export class CargoTypeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
